// extracted by mini-css-extract-plugin
export default {"QRCodeLinkModal":"QRCodeLinkModal__QRCodeLinkModal--to7mW","QRCodeLinkModal__row":"QRCodeLinkModal__QRCodeLinkModal__row--ZIUvu"};